var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "650" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("form.title")))]),
      _c("w-card-content", [
        _vm.dossierConfig.peppolRegistrationStatus == 0
          ? _c(
              "div",
              [
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      {
                        style: { padding: "10px 8px", lineHeight: "22px" },
                        attrs: { sm: "12" },
                      },
                      [_vm._v(" " + _vm._s(_vm.$ct("form.info")) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("w-input", {
                          attrs: {
                            label: _vm.$ct("form.company-name"),
                            fancy: "",
                          },
                          model: {
                            value: _vm.companyName,
                            callback: function ($$v) {
                              _vm.companyName = $$v
                            },
                            expression: "companyName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("w-input", {
                          staticClass: "mts",
                          attrs: {
                            label: _vm.$ct("form.vat-number"),
                            fancy: "",
                          },
                          model: {
                            value: _vm.vatNumber,
                            callback: function ($$v) {
                              _vm.vatNumber = $$v
                            },
                            expression: "vatNumber",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  { staticClass: "mts" },
                  [
                    _c(
                      "w-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("w-radio", {
                          attrs: {
                            checked: _vm.sendAndReceive == 1,
                            label:
                              "Ik wil graag documenten kunnen verzenden en ontvangen",
                          },
                          on: {
                            input: function ($event) {
                              _vm.sendAndReceive = 1
                            },
                          },
                        }),
                        _c("w-radio", {
                          attrs: {
                            checked: _vm.sendAndReceive == 0,
                            label: "Ik wil enkel documenten kunnen verzenden",
                          },
                          on: {
                            input: function ($event) {
                              _vm.sendAndReceive = 0
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm.dossierConfig.peppolRegistrationStatus == 1
          ? _c(
              "div",
              [
                _c(
                  "w-info",
                  { staticClass: "infobox-extra", attrs: { text: "" } },
                  [
                    _c("div", {
                      directives: [
                        {
                          name: "safe-html",
                          rawName: "v-safe-html",
                          value: _vm.peppolMsg,
                          expression: "peppolMsg",
                        },
                      ],
                    }),
                  ]
                ),
              ],
              1
            )
          : _c(
              "div",
              [
                _c(
                  "w-info",
                  { staticClass: "infobox-extra", attrs: { text: "" } },
                  [
                    _c("div", {
                      directives: [
                        {
                          name: "safe-html",
                          rawName: "v-safe-html",
                          value: _vm.peppolMsg,
                          expression: "peppolMsg",
                        },
                      ],
                    }),
                  ]
                ),
              ],
              1
            ),
      ]),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.close")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.isFormValid },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }